import React from 'react';

import { Box, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import { KeyLearningObjective } from '../../../../types';
import { PAYWALLED_CONTENT_SELECTORS } from '../../const';
import useStyles from '../VideoTabs/styles';

interface OverviewProps {
  summary?: string | null;
  keyLearningObjectives?: (KeyLearningObjective | null)[] | null | undefined;
}

const Overview: React.FC<OverviewProps> = ({ summary, keyLearningObjectives }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const summaryArr = summary ? summary.split(/\r?\n/) : [];

  return (
    <Box className={PAYWALLED_CONTENT_SELECTORS.OVERVIEW}>
      {summaryArr.length > 0 && (
        <Box className={classes.summaryWrapper} data-testid="overviewSummary">
          {summaryArr.map((item) => (
            <Typography key={item} className={classes.tabText}>
              {item}
            </Typography>
          ))}
        </Box>
      )}

      {keyLearningObjectives && keyLearningObjectives.length > 0 && (
        <>
          <Typography className={classes.tabHeader}>{t('page.video.keyLearningObj')}:</Typography>
          <ul className={classes.list} data-testid="keyLearningObjectives">
            {keyLearningObjectives.map((item) => (
              <li key={item?.id} className={classes.listItem}>
                <Typography className={classes.listText}>{item?.title}</Typography>
              </li>
            ))}
          </ul>
        </>
      )}
    </Box>
  );
};

export default Overview;
